import { useContext } from 'react'
import { PlayerContext } from '@contexts/index'

export const usePlayerContext = () => useContext(PlayerContext)
